import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { APP_SETTINGS } from "../models/backofficeConfiguration";
import { EditorialImageInformationResponse } from "../models/EditorialImage";
import { ErrorHandlerService } from "./errorHandler.service";
import { ExecuteService } from "./executeService.service";
import { CacheService } from './cache.service';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class EditorialImageCacheService {
  private apiURL = APP_SETTINGS.StorageApiUrl;

  constructor(private executeService: ExecuteService,
    private cacheService: CacheService,
    private errorHandler: ErrorHandlerService) {
  }

  public GetByPath(path: string): Observable<EditorialImageInformationResponse[]> {
    const url = `${this.apiURL}/v1/SearchImages/SearchByTags`;
    const tags: string[] = path.split("/");
    const raw:any = JSON.stringify(tags);

    return this.cacheService.get('geteditorialImageCacheByPath', this.executeService.ExecuteWithToken('post', url, null, raw)
      .pipe(
        map(response => this.mapResponse(response)),
        catchError(this.errorHandler.handleError<object[]>('EditorialImageCacheService_GetByPath', []))
      ));
  }

  private mapResponse(response: any): any {
    return response;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/editorialImageCache.service.ts